const AccessibilityRequirement = Object.freeze({
  STEP_FREE_ACCESS: 'step_free_access',
  SHORTER_WALKING_DISTANCES: 'shorter_walking_distances',
  REGULAR_SEATING_OR_REST_BREAKS: 'regular_seating_or_rest_breaks',
  ACCESSIBLE_BATHROOMS_OR_SHOWERS: 'accessible_bathrooms_or_showers',
  WHEELCHAIR_ACCESSIBLE_ACCOMMODATION:
    'wheelchair_accessible_accommodation',
  WHEELCHAIR_ACCESSIBLE_TRANSPORT: 'wheelchair_accessible_transport',
  QUIET_OR_LOW_SENSORY_ENVIRONMENTS: 'quiet_or_low_sensory_environments',
  HEARING_OR_VISUAL_SUPPORT: 'hearing_or_visual_support',
  MEDICATION_REFRIGERATION_OR_STORAGE:
    'medication_refrigeration_or_storage',
  TRAVELLING_WITH_AN_ASSISTANCE_ANIMAL:
    'travelling_with_an_assistance_animal',
} as const);

export type AccessibilityRequirement =
  (typeof AccessibilityRequirement)[keyof typeof AccessibilityRequirement];

export const allAccessibilityRequirements: [
  AccessibilityRequirement,
  ...AccessibilityRequirement[],
] = Object.values(AccessibilityRequirement) as [
  AccessibilityRequirement,
  ...AccessibilityRequirement[],
];

export default AccessibilityRequirement;
